import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import loadable from "@loadable/component";
const App = loadable(() => import("./App"));
import ReactGA from 'react-ga';

import * as serviceWorker from "./serviceWorker";

try {
	if (
		process.env.NODE_ENV === 'production' &&
		typeof window !== 'undefined' 
		// && [1, 2, 17, 18].includes(new Date().getDate())
	) {
		// trust me, only do it in production
		const captureError = async (error) => {
			try {
				console.error('error', error); // Log error to console for clarification
				// const Sentry = await import('@sentry/browser');
				// Sentry.init({
				// 	dsn: 'https://d18f4bed12e54ea0867281256c31e83c@o85028.ingest.sentry.io/4504548478812160',
				// 	tracesSampleRate: 0.1,
				// 	attachStacktrace: true,
				// 	release: 'nobroker-react@1.0.0',
				// 	integrations(integrations) {
				// 		return integrations.map((integration) => {
				// 			if (integration.name === 'GlobalHandlers') {
				// 				integration._options = {
				// 					...integration._options,
				// 					onerror: false,
				// 					onunhandledrejection: false,
				// 				};
				// 			}
				// 			return integration;
				// 		});
				// 	},
				// 	autoSessionTracking: false,
				// 	environment: 'production',
				// 	beforeSend(event, hint) {
				// 		const ignoreBeforeErrors = [
				// 			'InvalidCharacterError: The string contains invalid characters.',
				// 			'null is not an object',
				// 			'Loading chunk',
				// 			'Java exception was raised during method invocation',
				// 			'forEach is not a function',
				// 			'Unexpected number in JSON at position',
				// 			"Can't find variable: google", // 2679148289
				// 			`InvalidCharacterError: Failed to execute 'btoa' on 'Window': 
				// 				The string to be encoded contains characters outside of the Latin1 range`, // 2679150586
				// 			"Cannot read property 'getBoundingClientRect' of null", // 2656800484
				// 			"Cannot read properties of null (reading 'getBoundingClientRect')", // 2664957203
				// 			"SecurityError: Failed to execute 'pushState' on 'History'",
				// 			"'google' is not defined", // 2684449543
				// 			'Maximum call stack size exceeded', // 2684345205
				// 			"Cannot read properties of null (reading 'zoom')", // 2679386216
				// 			'SecurityError: The operation is insecure', // 2680839633
				// 			"Cannot read properties of null (reading 'body')", // 2679276651
				// 			"Cannot read properties of null (reading 'body')", // 2679276651
				// 			'Maximum update depth exceeded', // 2679634082
				// 			'not a LatLng or LatLngLiteral with finite coordinates: in property lat: not a number', // 2679738761
				// 			'Blocked a frame with origin "https://mobile-builder-crm.nobroker.in" from accessing a cross-origin frame.', // 2694221686
				// 			'ChunkLoadError',
				// 			'ChunkLoadError: Loading chunk',
				// 			"Cannot read property 'postMessage' of null",
				// 			'googleMapLoadCallBack is not a function',
				// 			'Java object is gone', // 2692636406
				// 			'r.indexOf is not a function', // 2696367718
				// 			"Cannot read property 'body' of null",
				// 			'e.database is not a function',
				// 			"Cannot read property 'zoom' of null",
				// 			'Loading CSS chunk',
				// 			'Converting circular structure to JSON',
				// 			"Failed to execute 'pushState' on 'History",
				// 			'not a LatLngBounds or LatLngBoundsLiteral: unknown property',
				// 			"Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.",
				// 			'String contains an invalid character',
				// 			"Object doesn't support property or method 'database",
				// 			"Failed to construct 'Worker': Maximum worker number has been reached", // UC browser known issue
				// 			"can't access dead object",
				// 			"Failed to execute 'setItem' on 'Storage'",
				// 			"Failed to execute 'drawImage' on 'CanvasRenderingContext2D'",
				// 		];
				// 		for (let i = 0; i <= ignoreBeforeErrors.length; i++) {
				// 			if (hint.originalException?.message?.includes(ignoreBeforeErrors[i])) {
				// 				return false;
				// 			}
				// 		}
				// 		return event;
				// 	},
				// 	ignoreErrors: [
				// 		'missing ) after argument list',
				// 		'Network Error',
				// 		'JSON Parse error: Invalid number',
				// 		'google is not defined',
				// 		'ResizeObserver loop limit exceeded',
				// 		"InvalidCharacterError: Failed to execute 'btoa' on 'Window'",
				// 		"Cannot read property 'getReadModeConfig' of undefined",
				// 		'QuotaExceededError: The quota has been exceeded',
				// 		'Illegal invocation',
				// 		'VAD_ON_APPBACK is not defined',
				// 		"Cannot read properties of undefined (reading 'closeActivity')",
				// 		'Java exception was raised during method invocation',
				// 		'this.scriptTagHolder is null',
				// 		'/Cannot read properties of null (reading $)/',
				// 		'InvalidCharacterError: The string contains invalid characters',
				// 		`SecurityError: Blocked a frame with origin 
				// 			"https://mobile-builder-crm.nobroker.in" from accessing a cross-origin frame. Protocols, domains, and ports must match.`,
				// 		`Blocked a frame with origin 
				// 			"https://mobile-builder-crm.nobroker.in" from accessing a cross-origin frame. Protocols, domains, and ports must match.`,
				// 		'No error message',
				// 		'JSON.stringify cannot serialize cyclic structures.',
				// 		'$ is not defined',
				// 	],
				// });
				// Sentry.captureException(error);
			} catch (e) {
				// all fails, reset window.onerror to prevent infinite loop on window.onerror
				console.error('Logging to Sentry failed', e);
				window.onerror = null;
			}
		};
		window.onerror = (message, url, line, column, error) => captureError(error);
		window.onunhandledrejection = (event) => captureError(event.reason);
	}
} catch (error) {
	console.error('got the error ', error);
}

ReactGA.initialize('UA-46762303-1', { titleCase: false });

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
